module.exports = __webpack_public_path__ + "img/coming-soon-dark.1c3bb3a2.svg";